import { TimePicker } from "@mui/x-date-pickers";
import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import Horario from "model/gestao/atividades/Horario";
import HorarioItem from "model/gestao/atividades/HorarioItem";
import HorarioTabelaDiaSemana from "model/gestao/atividades/HorarioTabelaDiaSemana";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import HorarioService from "service/gestao/atividades/HorarioService";

const horarioService = new HorarioService();

export default function HorarioCadastro() {

    const { setError, formState: { errors }, register, clearErrors } = useForm();

    const [horario, setHorario] = useState<Horario>(new Horario());
    const [tabela, setTabela] = useState<HorarioTabelaDiaSemana[]>([]);

    useEffect(() => {

        const tabelaLocal = [
            new HorarioTabelaDiaSemana(0, 'Domingo'),
            new HorarioTabelaDiaSemana(1, 'Segunda-feira'),
            new HorarioTabelaDiaSemana(2, 'Terça-feira'),
            new HorarioTabelaDiaSemana(3, 'Quarta-feira'),
            new HorarioTabelaDiaSemana(4, 'Quinta-feira'),
            new HorarioTabelaDiaSemana(5, 'Sexta-feira'),
            new HorarioTabelaDiaSemana(6, 'Sábado'),
        ];

        for (let index = 0; index < tabelaLocal.length; index++) {
            const dia = tabelaLocal[index];

            const filtro = horario.itens.filter(h => h.diaSemana === dia.diaSemana);
            console.log(filtro);
            if (filtro.length > 0) {
                dia.entrada1 = filtro[0].horaInicio;
                dia.saida1 = filtro[0].horaFim;
                if (filtro.length > 1) {
                    dia.entrada2 = filtro[1].horaInicio;
                    dia.saida2 = filtro[1].horaFim;
                }
            }

        }

        console.log(tabelaLocal);

        setTabela(tabelaLocal);

    }, [horario]);

    useEffect(() => {

        popularHorario();

    }, [tabela]);

    function validar() {

        if (!horario.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório" }, { shouldFocus: true })
            return false;
        }

        return true;
    }

    function popularHorario() {

        horario.itens = [];
        for (let index = 0; index < tabela.length; index++) {
            const dia = tabela[index];

            horario.itens.push(new HorarioItem(null, null, dia.diaSemana, dia.entrada1, dia.saida1));
            horario.itens.push(new HorarioItem(null, null, dia.diaSemana, dia.entrada2, dia.saida2));
        }
    }

    return (

        <BaseCadastro model={horario} service={horarioService} setModel={(value: Horario) => setHorario(value)} validar={() => validar()} urlService="/horario" pathCadastro="/horario" tituloPagina={'Horário'}>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText required value={horario.nome} style={{ width: '100%' }}
                        className={errors.nome ? "p-invalid" : ""}
                        {...register("nome", {
                            onChange: (e) => {
                                clearErrors("nome");
                                setHorario({ ...horario, nome: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Minutos de tolerância para cada horário</Label>
                <div className="col-sm-12">
                    <InputNumber inputStyle={{ textAlign: 'center' }} value={horario.tolerancia | 0} onChange={(e) => setHorario({ ...horario, tolerancia: e.value ? e.value : 0 })} style={{ width: 260 }} />
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <DataTable
                        header="Horários"
                        emptyMessage="Nenhum horário encontrado"
                        value={tabela}
                    >
                        <Column field="descricao" header="" style={{ width: 160 }} />
                        <Column field="entrada1" header="Entrada 1" style={{ textAlign: 'center', width: 160 }}
                            body={(rowData: HorarioTabelaDiaSemana) => {
                                return <TimePicker
                                    value={dayjs().hour(0).minute(rowData.entrada1)}
                                    className="time-picker-horario"
                                    onChange={(newValue) => {
                                        rowData.entrada1 = newValue ? ((newValue.hour() * 60) + newValue.minute()) : 0;
                                        setTabela([...tabela]);
                                    }}
                                />;

                            }}
                        />
                        <Column field="saida1" header="Saída 1" style={{ textAlign: 'center', width: 160 }}
                            body={(rowData: HorarioTabelaDiaSemana) => {
                                return <TimePicker
                                    value={dayjs().hour(0).minute(rowData.saida1)}
                                    className="time-picker-horario"
                                    onChange={(newValue) => {
                                        rowData.saida1 = newValue ? ((newValue.hour() * 60) + newValue.minute()) : 0;
                                        setTabela([...tabela]);
                                    }}
                                />;

                            }}
                        />
                        <Column field="entrada2" header="Entrada 2" style={{ textAlign: 'center', width: 160 }}
                            body={(rowData: HorarioTabelaDiaSemana) => {
                                return <TimePicker
                                    value={dayjs().hour(0).minute(rowData.entrada2)}
                                    className="time-picker-horario"
                                    onChange={(newValue) => {
                                        rowData.entrada2 = newValue ? ((newValue.hour() * 60) + newValue.minute()) : 0;
                                        setTabela([...tabela]);
                                    }}
                                />;

                            }}
                        />
                        <Column field="saida2" header="Saída 2" style={{ textAlign: 'center', width: 160 }}
                            body={(rowData: HorarioTabelaDiaSemana) => {
                                return <TimePicker
                                    value={dayjs().hour(0).minute(rowData.saida2)}
                                    className="time-picker-horario"
                                    onChange={(newValue) => {
                                        rowData.saida2 = newValue ? ((newValue.hour() * 60) + newValue.minute()) : 0;
                                        setTabela([...tabela]);
                                    }}
                                />;

                            }}
                        />
                    </DataTable>
                </div>
            </div>

        </BaseCadastro>
    )
}
